import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtigoCSSBuySpreadsheet from "../pages/artigo-cssbuy-spreadsheet/page";
import ArtigoCSSBuySneakers from "../pages/artigo-cssbuy-sneakers/page";
import ArtigoCSSBuyRoupas from "../pages/artigo-cssbuy-roupas/page";
import ArtigoCSSBuyBolsas from "../pages/artigo-cssbuy-bolsas/page";
import ArtigoCSSBuyEletronicos from "../pages/artigo-cssbuy-eletronicos/page";
import ArtigoCSSBuyPerfumes from "../pages/artigo-cssbuy-perfumes/page";
import ArtigoCSSBuyAcessorios from "../pages/artigo-cssbuy-acessorios/page";
import ArtigoCSSBuyTamanhos from "../pages/artigo-cssbuy-tamanhos/page";
import ArtigoCSSBuyComparacao from "../pages/artigo-cssbuy-comparacao/page";
import ArtigoCSSBuyTaxas from "../pages/artigo-cssbuy-taxas/page";
import ArtigoCSSBuyWeidian from "../pages/artigo-cssbuy-weidian/page";
import ArtigoCSSBuyEnvio from "../pages/artigo-cssbuy-envio/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/artigo-cssbuy-spreadsheet", element: <ArtigoCSSBuySpreadsheet /> },
  { path: "/artigo-cssbuy-sneakers", element: <ArtigoCSSBuySneakers /> },
  { path: "/artigo-cssbuy-roupas", element: <ArtigoCSSBuyRoupas /> },
  { path: "/artigo-cssbuy-bolsas", element: <ArtigoCSSBuyBolsas /> },
  { path: "/artigo-cssbuy-eletronicos", element: <ArtigoCSSBuyEletronicos /> },
  { path: "/artigo-cssbuy-perfumes", element: <ArtigoCSSBuyPerfumes /> },
  { path: "/artigo-cssbuy-acessorios", element: <ArtigoCSSBuyAcessorios /> },
  { path: "/artigo-cssbuy-tamanhos", element: <ArtigoCSSBuyTamanhos /> },
  { path: "/artigo-cssbuy-comparacao", element: <ArtigoCSSBuyComparacao /> },
  { path: "/artigo-cssbuy-taxas", element: <ArtigoCSSBuyTaxas /> },
  { path: "/artigo-cssbuy-weidian", element: <ArtigoCSSBuyWeidian /> },
  { path: "/artigo-cssbuy-envio", element: <ArtigoCSSBuyEnvio /> },
  { path: "*", element: <NotFound /> },
];

export default routes;